/** Sufixo DNS compartilhado por FIT e Enterprise Basic; alinhar a `TenantResolution:BarukClusterHostSuffix` na API. */
export function getBarukClusterHostSuffix(): string {
  return process.env.REACT_APP_TENANT_BARUK_CLUSTER_HOST_SUFFIX?.trim() ?? '';
}
